import type { LucideIcon } from 'lucide-react'

/** Uma escolha dentro de um campo de filtro. `all` é o sentinela de "sem filtro":
 *  o valor vazio só existe do lado da URL, para o parâmetro sumir dela. */
export interface FilterOption {
  readonly value: string
  readonly label: string
  /** Quando presente, vira o número ao lado do rótulo (ex.: chips de status). */
  readonly count?: number
}

export interface FilterField {
  readonly key: string
  readonly label: string
  readonly options: readonly FilterOption[]
}

export interface FilterSection {
  readonly title: string
  /** Linha de apoio abaixo do título — para explicar de onde vem o recorte. */
  readonly hint?: string
  readonly fields: readonly FilterField[]
}

/** Atalho: uma combinação de filtros que a escola pede toda semana. */
export interface QuickFilter {
  readonly label: string
  readonly icon: LucideIcon
  readonly values: Readonly<Record<string, string>>
}

/** Um filtro ligado, do jeito que aparece no chip abaixo da barra de busca. */
export interface ActiveChip {
  readonly key: string
  readonly label: string
}

export type FilterValues = Record<string, string>

/** Espelha ListPagination::PER_PAGE_OPTIONS (app/controllers/concerns/list_pagination.rb).
 *  O backend clampa no primeiro e no último valor, então mudar aqui sozinho não basta. */
export const PER_PAGE_OPTIONS = [10, 25, 50, 100] as const

/** Constrói o mapa de valores vazios a partir das chaves conhecidas. */
export function emptyValues(keys: readonly string[]): FilterValues {
  return Object.fromEntries(keys.map((key) => [key, ''])) as FilterValues
}

/** Todas as chaves de filtro declaradas nas seções, na ordem em que aparecem. */
export function filterKeys(sections: readonly FilterSection[]): string[] {
  return sections.flatMap((section) => section.fields.map((field) => field.key))
}
